<template>
  <div class="wrapper">
    <h4 class="success-text">{{$t('pages_wechat_configs_success_1177')}}</h4>
  </div>
</template>

<script>
import i18n from '../../locales/index'

export default {
  name: 'wechat_authorize_success'
}
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: center;
  line-height: 200px;
  height: 200px;
}
.success-text {
  color: green;
  font-size: 20px;
}
</style>
